import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './loader.scss';

const Loader = ({ bubbleClassName, dataHook }) => (
  <div className={styles.container} data-hook={dataHook}>
    <span className={classNames(styles.dot, bubbleClassName)} />
    <span className={classNames(styles.dot, bubbleClassName)} />
    <span className={classNames(styles.dot, bubbleClassName)} />
  </div>
);

Loader.propTypes = {
  bubbleClassName: PropTypes.string,
  dataHook: PropTypes.string,
};

Loader.defaultProps = {
  bubbleClassName: 'blog-text-background-color',
};

export default Loader;
